import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { selectionProcessesPublic } from '@/services/selectionProcesses';
import { buildRegistrationSchema } from './validationSchema';
import RegistrationFormFields from './components/RegistrationFormFields';
import { PATHS } from '@/routes/paths';

export default function PublicRegistrationForm() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [process, setProcess] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    selectionProcessesPublic
      .getBySlug(slug)
      .then(res => setProcess(res.data))
      .catch(err => {
        if ([404, 410].includes(err?.response?.status)) {
          navigate(PATHS.SELETIVO.PUBLIC_CLOSED(slug));
        } else {
          setLoadError(err?.response?.data?.errors || 'Erro ao carregar.');
        }
      });
  }, [slug, navigate]);

  const initial = {
    full_name: '',
    cpf: '',
    birth_date: '',
    email: '',
    phone: '',
    regional_id: '',
    institution_id: '',
    current_education_level: '',
    desired_grade: '',
    preferred_shift: '',
    special_needs: false,
    special_needs_description: '',
    lgpd_accepted: false,
    honeypot: ''
  };

  if (loadError) return <p className="p-4 text-red-600">Erro ao carregar o seletivo.</p>;
  if (!process) return <p className="p-4">Carregando...</p>;

  return (
    <main className="mx-auto max-w-2xl p-4">
      <h1 className="text-2xl font-bold">{process.attributes.name}</h1>
      <p className="mb-4 text-gray-700">{process.attributes.description}</p>

      <Formik
        initialValues={initial}
        validationSchema={buildRegistrationSchema()}
        onSubmit={async (values, { setSubmitting, setErrors }) => {
          setSubmitError(null);
          try {
            const res = await selectionProcessesPublic.submitRegistration(slug, values);
            navigate(PATHS.SELETIVO.PUBLIC_SUCCESS(slug), { state: { protocol: res.data?.protocol } });
          } catch (err) {
            const errors422 = err?.response?.data?.errors;
            if (Array.isArray(errors422)) {
              const fieldErrors = {};
              errors422.forEach(e => {
                const ptr = e?.source?.pointer || '';
                const m = ptr.match(/\/data\/attributes\/(\w+)/);
                if (m) fieldErrors[m[1]] = e.detail;
              });
              setErrors(fieldErrors);
            }
            setSubmitError('Erro ao enviar. Verifique os campos.');
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            <RegistrationFormFields
              slug={slug}
              values={values}
              setFieldValue={setFieldValue}
            />
            {submitError && <p className="mt-3 text-red-600">{submitError}</p>}
            <button
              type="submit"
              disabled={isSubmitting}
              className="mt-4 rounded bg-blue-600 px-4 py-2 text-white disabled:opacity-50"
            >
              {isSubmitting ? 'Enviando...' : 'Enviar inscrição'}
            </button>
          </Form>
        )}
      </Formik>
    </main>
  );
}
